import React from "react";

const defaultContext = {
  configuration: {},
  currentCompanyId: null,
  currentCompanyInfo: {},
  currentCompanyPlan: null,
  currentUserInfo: {},
  token: null,
  isSuperuser: false,
};

const ControlHubContext = React.createContext(defaultContext);

ControlHubContext.displayName = "ControlHub Context";

export default ControlHubContext;
